import { useEffect, useState } from "react";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import Header from "../../Header";
import ReportScreen from "../../../../common/enums/ReportScreens";
import ReportFiltersComponent from "../ReportFiltersComponent";
import ReportFiltersLoading from "../ReportFiltersLoading";
import {
  Button,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { ReportFilters } from "../../../../domain/models/report-filters";
import moment from "moment";
import TargetTableDetail from "./TargetTableDetail";
import { FetchState } from "../../../../domain/models/fetch-state";
import { TargetStore } from "../../../../store/main/TargetStore";
import CustomerTableLoading from "../CustomerTableLoading";
import NoRecordFound from "../NoRecordFound";

const TargetDesktop = () => {
  const { decodeToken, userDetails, userRole, filterStore } =
    CustomerDatabaseStore();
  const {
    fetchTarget,
    TargetData,
    TargetState,
    TargetFilter,
    pageData,
    currentPageNumber,
    handlePageNumber,
  } = TargetStore();

  const [editingRow, setEditingRow] = useState<string | null>(null);

  const filterData = (filters: ReportFilters) => {
    filterStore.date = filters.date?.toString();
    const month = moment(filters.date?.toString()).format("MM");
    const year = moment(filters.date?.toString()).format("yy");
    TargetFilter.month_year = `${year}${month}`;
    TargetFilter.q = filters.search;
    TargetFilter.zone_ids = filters.zone;
    TargetFilter.region_ids = filters.region;
    TargetFilter.area_ids = filters.area;
    TargetFilter.headquarter_ids = filters.headquarter;
    TargetFilter.page = 1;
    fetchTarget(TargetFilter);
  };

  const clearData = () => {
    const currDate = new Date();
    const year = currDate.getFullYear();
    const month = String(currDate.getMonth() + 1).padStart(2, "0");
    const monthYear = `${year}${month}`;
    TargetFilter.month_year = monthYear;
    TargetFilter.q = "";
    TargetFilter.zone_ids = [];
    TargetFilter.region_ids = [];
    TargetFilter.area_ids = [];
    TargetFilter.headquarter_ids = [];
    TargetFilter.page = 1;
    fetchTarget(TargetFilter);
  };

  const onTargetPageChange = (value: number) => {
    TargetFilter.page = value;
    fetchTarget(TargetFilter);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    handlePageNumber(value);
    onTargetPageChange(value);
  };

  useEffect(() => {
    const currDate = new Date();
    const year = currDate.getFullYear();
    const month = String(currDate.getMonth() + 1).padStart(2, "0");
    const monthYear = `${year}${month}`;
    TargetFilter.month_year = monthYear;
    TargetFilter.page = 1;
    decodeToken();
    fetchTarget(TargetFilter);
  }, []);

  return (
    <Stack p={2} gap={2}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Header title="Target" />
        <Button
          variant={"contained"}
          onClick={() => {}}
          startIcon={<DownloadIcon />}
        >
          Download
        </Button>
      </Stack>
      {Object.keys(userDetails).length > 0 ? (
        <ReportFiltersComponent
          type={ReportScreen.TARGET}
          successCallback={filterData}
          clearSuccessCallBack={clearData}
          userRole={userRole.role}
          userDetails={userDetails}
          gridColumns={20}
          territoryMultiSelect={false}
        />
      ) : (
        <ReportFiltersLoading />
      )}
      {TargetState === FetchState.LOADING && <CustomerTableLoading />}
      {TargetState === FetchState.ERROR && <NoRecordFound height="70vh" />}
      {TargetState === FetchState.SUCCESS && (
        <>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>zone</TableCell>
                  <TableCell>region</TableCell>
                  <TableCell>area</TableCell>
                  <TableCell>headquarter</TableCell>
                  <TableCell>headquarter_id</TableCell>
                  <TableCell>product_code</TableCell>
                  <TableCell>product</TableCell>
                  <TableCell>product_id</TableCell>
                  <TableCell>target</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {TargetData.map((data) => (
                  <TargetTableDetail
                    key={`${data.headquarter_id}-${data.product_id}`}
                    data={data}
                    isEditing={
                      editingRow === `${data.headquarter_id}-${data.product_id}`
                    }
                    setEditingRow={setEditingRow}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {Math.ceil(pageData.total / pageData.per_page) !== 1 && (
            <Stack alignItems="center" pb={1}>
              <Pagination
                count={Math.ceil(pageData.total / pageData.per_page)}
                variant="outlined"
                page={currentPageNumber}
                onChange={handlePageChange}
              />
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
};

export default TargetDesktop;
